import styled from 'styled-components';
import Image from '../Image';

export const BrandsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.lg};

  a {
    width: calc((100% - 2 * ${({ theme }) => theme.spacing.lg}) / 3);
  }

  @media (min-width: ${props => props.theme.mediaSm}) {
    flex-wrap: nowrap;
    gap: ${({ theme }) => theme.spacing.xl};

    a {
      width: auto;
    }
  }
`;

export const StyledImage = styled(Image)`
  max-width: 100%;
  height: auto;
`;
